import ShipTosShow from './shipTosShow';
import ShipTosList from './shipTosList';
import ShipTosEdit from './shipTosEdit';

export default {
    show: ShipTosShow,
    list: ShipTosList,
    edit: ShipTosEdit,
}